import { baseQuery } from '../baseQuery';

export const getVoipStatuses = async () => {
  const { data } = await baseQuery('voip-statuses');

  return data;
};
